import { addAllToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { DeleteMessageFulfilledAction } from '../../../domains/deleteMessage/actions.types';
import type {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import type {
  ThreadPinToTeamsMeetingFeedFulfilledAction,
  ThreadUnpinFromTeamsMeetingFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import type { PublishTeamsMeetingMessageFulfilledAction } from '../../../domains/publishers/actions.types';
import type { ThreadMoveCompletedAction } from '../../../domains/threadMove/actions.types';
import {
  removeThreadFromAnyPinnedInstance,
  removeThreadFromAnyPinnedInstanceIfDeleted,
} from '../removeDeletedPinnedThread';
import type { ThreadsPinnedToFeeds } from '../types';
export type ThreadsPinnedToTeamsMeetingFeedsAction =
  | DeleteMessageFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | PublishTeamsMeetingMessageFulfilledAction
  | ThreadMoveCompletedAction
  | ThreadPinToTeamsMeetingFeedFulfilledAction
  | ThreadUnpinFromTeamsMeetingFeedFulfilledAction;
const initialState: ThreadsPinnedToFeeds = {};
const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToTeamsMeetingFeedsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'PUBLISHER.PUBLISH_TEAMS_MEETING_MESSAGE_FULFILLED': {
      const { teamsMeetingId, threadId, isPinned } = action.payload;
      if (!isPinned) {
        return state;
      }
      const existing = state[teamsMeetingId];

      return {
        ...state,
        [teamsMeetingId]: {
          id: teamsMeetingId,
          threadIds: [threadId, ...existing.threadIds],
        },
      };
    }
    case 'THREAD.PIN_TO_TEAMS_MEETING_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'THREAD.UNPIN_FROM_TEAMS_MEETING_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToTeamsMeetingFeeds);
    case 'MESSAGE.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstanceIfDeleted(
        state,
        action.payload.threadId,
        action.payload.deletionOutcome === 'THREAD_REMOVED'
      );
    case 'THREAD.MOVE_COMPLETED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    default:
      return state;
  }
};
export default reducer;
